import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.875 0.000507706C4.49342 0.0104768 4.12949 0.165624 3.85789 0.435009L3.85645 0.436451L0.436447 3.85645L0.436444 3.85645L0.435004 3.8579C0.157888 4.13729 0.00166136 4.51439 4.44055e-06 4.9079H0V4.91V12.5C0 12.8978 0.158035 13.2794 0.43934 13.5607C0.720644 13.842 1.10217 14 1.5 14L2.13361 14V9.5C2.13361 9.15863 2.29883 8.86198 2.53828 8.66439C2.7743 8.46961 3.07276 8.375 3.36452 8.375H10.6354C10.9272 8.375 11.2257 8.46961 11.4617 8.66439C11.7011 8.86198 11.8664 9.15863 11.8664 9.5V14L12.5 14C12.8978 14 13.2794 13.842 13.5607 13.5607C13.842 13.2794 14 12.8978 14 12.5V1.5C14 1.10218 13.842 0.720649 13.5607 0.439344C13.2794 0.15804 12.8978 4.41074e-06 12.5 4.41074e-06L11.8664 0V3.5C11.8664 3.82845 11.7158 4.1227 11.4837 4.32488C11.2543 4.52466 10.9595 4.625 10.6672 4.625H6.07414C5.78187 4.625 5.48711 4.52466 5.2577 4.32488C5.02555 4.1227 4.875 3.82845 4.875 3.5V0.000507706ZM10.6164 0H6.125V3.375H10.6164V0ZM10.6164 14H3.38361V9.625H10.6164V14Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }